(() => {
  const DUR_DESKTOP = 35; // seconds
  const DUR_MOBILE  = 35;

  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  function setDuration(wrap) {
    wrap.style.setProperty('--marquee-duration', `${isMobile() ? DUR_MOBILE : DUR_DESKTOP}s`);
  }

  function makeMarquee(track, wrapClass) {
    if (!track || !track.children || track.children.length < 3) return false;
    if (track.dataset.marqueeInit === '1') return true;
    track.dataset.marqueeInit = '1';

    // Wrap
    const wrap = document.createElement('div');
    wrap.className = `marquee-wrap marquee-animate ${wrapClass || ''}`;
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    track.classList.add('marquee-track');

    // Duplicate exactly once for seamless -50% loop
    const originals = Array.from(track.children);
    originals.forEach(el => track.appendChild(el.cloneNode(true)));

    setDuration(wrap);

    // Pause on hover (desktop) and touch (mobile)
    wrap.addEventListener('mouseenter', () => wrap.classList.add('marquee-paused'));
    wrap.addEventListener('mouseleave', () => wrap.classList.remove('marquee-paused'));
    wrap.addEventListener('touchstart', () => wrap.classList.add('marquee-paused'), { passive: true });
    wrap.addEventListener('touchend', () => wrap.classList.remove('marquee-paused'), { passive: true });

    return true;
  }

  function findCategoryTrack(section) {
    // Hyper variants for category list
    return (
      section.querySelector('.collection-list__items') ||
      section.querySelector('.collection-list') ||
      section.querySelector('.slider__grid') ||
      section.querySelector('.swiper-wrapper') ||
      section.querySelector('.flickity-slider') ||
      section.querySelector('ul')
    );
  }

  function findFeaturedTrack(section) {
    return (
      section.querySelector('.product-grid') ||
      section.querySelector('ul[role="list"]') ||
      section.querySelector('[role="list"]') ||
      section.querySelector('.grid') ||
      section.querySelector('.slider__grid') ||
      section.querySelector('.swiper-wrapper')
    );
  }

  function initCategory() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(section => {
      const id = section.id || '';
      const txt = (section.innerText || '').toLowerCase();

      const isCategorySection =
        txt.includes('shop by category') ||
        id.includes('__collection_cards') ||
        id.includes('__collection_list');

      if (!isCategorySection) return;

      const track = findCategoryTrack(section);
      if (track) makeMarquee(track, 'category-marquee');
    });
  }

  function initFeatured() {
    document
      .querySelectorAll('[id^="shopify-section-"][id*="__featured_collection"]')
      .forEach(section => {
        const track = findFeaturedTrack(section);
        if (track) makeMarquee(track, 'featured-marquee');
      });
  }

  function initAll() {
    initCategory();
    initFeatured();

    // Update durations when breakpoint changes
    document.querySelectorAll('.marquee-wrap').forEach(setDuration);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  setTimeout(initAll, 800);
  setTimeout(initAll, 2000);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.marquee-wrap').forEach(setDuration);
  });
})();